var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-setting roomGroup",
      attrs: { "data-grm-comp": "GroupSetting" },
    },
    [
      _c("div", { staticClass: "room-setting-header direction-column" }, [
        _c("div", { staticClass: "title-wrapper" }, [
          _c("p", { staticClass: "title large" }, [
            _vm._v(_vm._s(_vm.$t("group.setting.title"))),
          ]),
          _c(
            "div",
            { staticClass: "button-box" },
            [
              _c("div", { staticClass: "room-group-setting-button-wrapper" }, [
                _c(
                  "button",
                  {
                    staticClass: "room-group-setting-button",
                    on: { click: _vm.onChangeRoomGroupDiscussion },
                  },
                  [_vm._v(_vm._s(_vm.$t("group.setting.change")))]
                ),
                _c(
                  "button",
                  {
                    staticClass: "room-group-setting-button end",
                    on: { click: _vm.onEndRoomGroupDiscussion },
                  },
                  [_vm._v(_vm._s(_vm.$t("group.setting.quit")))]
                ),
              ]),
              _c("GrmCloseBtn", {
                attrs: { color: "white" },
                on: { click: _vm.onCloseRoomSetting },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "room-setting-body roomGroup" },
        [
          _c("perfect-scrollbar", [
            _c("div", { staticClass: "room-setting-list-scroll" }, [
              _c("ul", { staticClass: "room-setting-list" }, [
                _c(
                  "li",
                  { staticClass: "room-setting-item roomGroup" },
                  [
                    _c("GrmSelect", {
                      attrs: {
                        label: _vm.$t("group.setting.amount"),
                        options: [
                          {
                            value: 2,
                            title: _vm.$t("group.setting.groupCount", {
                              0: "2",
                            }),
                            selected: _vm.roomGroupCount === 2,
                          },
                          {
                            value: 3,
                            title: _vm.$t("group.setting.groupCount", {
                              0: "3",
                            }),
                            selected: _vm.roomGroupCount === 3,
                          },
                          {
                            value: 4,
                            title: _vm.$t("group.setting.groupCount", {
                              0: "4",
                            }),
                            selected: _vm.roomGroupCount === 4,
                          },
                          {
                            value: 5,
                            title: _vm.$t("group.setting.groupCount", {
                              0: "5",
                            }),
                            selected: _vm.roomGroupCount === 5,
                          },
                          {
                            value: 6,
                            title: _vm.$t("group.setting.groupCount", {
                              0: "6",
                            }),
                            selected: _vm.roomGroupCount === 6,
                          },
                          {
                            value: 7,
                            title: _vm.$t("group.setting.groupCount", {
                              0: "7",
                            }),
                            selected: _vm.roomGroupCount === 7,
                          },
                          {
                            value: 8,
                            title: _vm.$t("group.setting.groupCount", {
                              0: "8",
                            }),
                            selected: _vm.roomGroupCount === 8,
                          },
                          {
                            value: 9,
                            title: _vm.$t("group.setting.groupCount", {
                              0: "9",
                            }),
                            selected: _vm.roomGroupCount === 9,
                          },
                          {
                            value: 10,
                            title: _vm.$t("group.setting.groupCount", {
                              0: "10",
                            }),
                            selected: _vm.roomGroupCount === 10,
                          },
                        ],
                      },
                      model: {
                        value: _vm.roomGroupCount,
                        callback: function ($$v) {
                          _vm.roomGroupCount = $$v
                        },
                        expression: "roomGroupCount",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "li",
                  { staticClass: "room-setting-item roomGroup" },
                  [
                    _c("GrmSwitch", {
                      attrs: {
                        id: "showRoomGroupUserInFilmArea",
                        label: _vm.$t("group.setting.duplicate"),
                        value: _vm.showRoomGroupUserInFilmArea,
                      },
                      on: {
                        "update:value": function ($event) {
                          _vm.showRoomGroupUserInFilmArea = $event
                        },
                      },
                    }),
                  ],
                  1
                ),
                !_vm.isRoomMode("group")
                  ? _c(
                      "li",
                      { staticClass: "room-setting-item roomGroup" },
                      [
                        _c("GrmSwitch", {
                          attrs: {
                            id: "showRoomGroupUserAutoDivide",
                            label: _vm.$t("group.setting.randomSplit"),
                            value: _vm.showRoomGroupUserAutoDivide,
                          },
                          on: {
                            "update:value": function ($event) {
                              _vm.showRoomGroupUserAutoDivide = $event
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "room-group-setting-button-wrapper pc" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "room-group-setting-button",
                      on: { click: _vm.onChangeRoomGroupDiscussion },
                    },
                    [_vm._v(_vm._s(_vm.$t("group.setting.change")))]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "room-group-setting-button end",
                      staticStyle: { "margin-top": "10px" },
                      on: { click: _vm.onEndRoomGroupDiscussion },
                    },
                    [_vm._v(_vm._s(_vm.$t("group.setting.quit")))]
                  ),
                ]
              ),
            ]),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "room-setting-footer" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }